import styled from 'styled-components';
import { Tier } from 'dragonmouse-shared/interfaces';

export const Base = styled.div<{ isCurrent?: boolean; tier?: Tier.TIER_1 | Tier.TIER_2 }>`
	background: ${(p) => p.theme.gray[0]};
	border-radius: 12px;
	padding: 32px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	transition: all 0.3s ease-in-out;
	display: flex;
	flex-direction: column;
	text-align: left;
	position: relative;

	&:hover {
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
	}
`;

export const SubscriptionHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 24px;
	gap: 12px;
`;

export const PlanNameBlock = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const PlanName = styled.div<{ tier?: Tier.TIER_1 | Tier.TIER_2 }>`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => {
		if (p.tier === Tier.TIER_1 || p.tier === Tier.TIER_2) return p.theme.blue[400];
		return p.theme.gray[1000];
	}};
`;

export const PlanPrice = styled.div<{ tier?: Tier.TIER_1 | Tier.TIER_2 }>`
	font-size: 28px;
	font-weight: 700;
	color: ${(p) => {
		if (p.tier === Tier.TIER_1 || p.tier === Tier.TIER_2) return p.theme.blue[400];
		return p.theme.gray[1000];
	}};
`;

export const PricePeriod = styled.span`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	font-weight: 500;
`;

export const UpgradeDescription = styled.p`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	margin-bottom: 16px;
	line-height: 1.5;
`;

export const RenewalInfoBox = styled.div`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	margin-bottom: 24px;
`;

// Fixed height so card doesn't resize when chip appears/disappears
export const ChipSlot = styled.div`
	min-height: 28px;
	display: flex;
	align-items: center;
	margin-top: 3px;
`;

export const Features = styled.ul`
	list-style: none;
	margin-bottom: 24px;
	flex-grow: 1;
	padding: 0;
`;

export const Feature = styled.li<{ tier?: Tier.TIER_1 | Tier.TIER_2 }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 0;
	font-size: 15px;
	line-height: 22px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[1000]};
`;

export const Checkmark = styled.svg<{ tier?: Tier.TIER_1 | Tier.TIER_2 }>`
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	color: ${(p) => p.theme.green[600]};
`;

export const CancelLink = styled.button`
	display: block;
	text-align: center;
	margin-top: 12px;
	color: ${(p) => p.theme.gray[600]};
	font-size: 13px;
	font-weight: 500;
	text-decoration: none;
	transition: color 0.2s ease-in-out;
	background: none;
	border: none;
	padding: 0;
	width: 100%;
	font-family: inherit;

	&:hover {
		color: ${(p) => p.theme.gray[400]};
		text-decoration: none;
	}
`;

